module.exports = __webpack_public_path__ + "static/media/11.83569a01.jpg";